<template>
  <div class="enterpriseTreeManagement_zk">
    <el-card shadow="always" :body-style="{ padding: '0px 20px 20px 20px' }">
      <div slot="header"></div>
      <div class="content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="设置构件库" name="first">
            <br />
            <el-row>
              <el-col :span="12" :offset="0">
                <el-input
                  placeholder="搜索企业"
                  suffix-icon="el-icon-search"
                  v-model="GouKeyword"
                  size="small"
                  style="width: 45%"
                  v-on:input="GetCompanyNewList()"
                ></el-input>
                <el-button
                  style="float: right; margin-right: 35px"
                  type="primary"
                  size="small"
                  @click="loadGou()"
                  >加载</el-button
                >
                <div style="width: 96%; margin-top: 20px">
                  <el-table
                    ref="multipleTableA"
                    :data="tableData"
                    v-loading="tableLoading"
                    element-loading-text="列表加载中..."
                    row-key="multipleTableA"
                    @row-click="handleRowClick"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    max-height="635px"
                    border
                  >
                    <el-table-column type="index" label="序号" width="230">
                    </el-table-column>
                    <el-table-column label="全部企业">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      type="selection"
                      :reserve-selection="true"
                      width="55"
                    >
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    class="ppfixed"
                    style="left: 20%"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    align="center"
                    background
                  >
                  </el-pagination>
                </div>
              </el-col>
              <el-col :span="12" :offset="0">
                <div
                  style="
                    float: left;
                    width: 1px;
                    height: 77vh;
                    background: #cfcfcf;
                  "
                ></div>
                <el-button
                  type="text"
                  @click="UpdateFamilyZoomPosition('up')"
                  style="margin-left: 35px"
                >
                  <img
                    src="../../../assets/img/company/shang.png"
                    style="width: 16px; height: 16px; margin-bottom: 5px"
                  /><span style="font-size: 15px; color: #035dff">
                    上移</span
                  ></el-button
                >

                <el-button
                  type="text"
                  @click="UpdateFamilyZoomPosition('down')"
                  style="margin-left: 35px"
                >
                  <img
                    src="../../../assets/img/company/xia.png"
                    style="width: 16px; height: 16px; margin-bottom: 5px"
                  /><span style="font-size: 15px; color: #035dff">
                    下移</span
                  ></el-button
                >
                <el-button
                  style="float: right; margin-right: 10px"
                  type="primary"
                  size="small"
                  @click="unLoadFamilyZoom()"
                  >卸载</el-button
                >
                <div style="width: 95%; margin: 5px 0px 0px 35px">
                  <el-table
                    ref="unloadTable"
                    row-key="unloadTable"
                    :data="tableData2"
                    v-loading="tableLoading"
                    element-loading-text="构件加载中..."
                    @row-click="unloadhandleRowClick"
                    @selection-change="unloadhandleSelectionChange"
                    style="width: 100%"
                    max-height="635px"
                    border
                  >
                    <el-table-column type="index" label="序号" width="230">
                    </el-table-column>
                    <el-table-column label="全部企业">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      type="selection"
                      :reserve-selection="true"
                      width="55"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="全部企业" name="second">
            <div class="company">
              <el-row>
                <el-col :span="20" :offset="0">&nbsp;</el-col>
                <el-col :span="4" :offset="0">
                  <el-input
                    style="width: 100%"
                    placeholder="搜索企业名称"
                    prefix-icon="el-icon-search"
                    v-model="comKeyword"
                    size="small"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div style="border: 1px solid #ebeef5; margin-top: 20px">
              <el-table
                ref="daimultipleTable"
                :data="tableData"
                v-loading="tableLoading"
                element-loading-text="列表加载中..."
                row-key="daimultipleTable"
                style="width: 100%"
                max-height="690px"
              >
                <el-table-column prop="name" label="企业" align="center">
                </el-table-column>
                <el-table-column prop="Account" label="账号" align="center">
                </el-table-column>
                <el-table-column label="所在企业树" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.zoomNames }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #035dff"
                      type="text"
                      @click="edit(scope.row, 1)"
                      >修改</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="ppfixed"
                style="bottom: 5px"
                @size-change="comhandleSizeChange"
                @current-change="comhandleCurrentChange"
                :current-page="comcurrentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="compageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="comtotal"
                align="center"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="全部人员" name="third">
            <div class="company">
              <el-row>
                <el-col :span="20" :offset="0">&nbsp;</el-col>
                <el-col :span="4" :offset="0">
                  <el-input
                    style="width: 100%"
                    placeholder="搜索人员名称"
                    prefix-icon="el-icon-search"
                    v-model="perKeyword"
                    size="small"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div style="border: 1px solid #ebeef5; margin-top: 20px">
              <el-table
                ref="daimultipleTable"
                :data="pertableData"
                v-loading="tableLoading"
                element-loading-text="列表加载中..."
                style="width: 100%"
                row-key="daimultipleTable"
                max-height="690px"
              >
                <el-table-column prop="name" label="人员" align="center">
                </el-table-column>
                <el-table-column prop="Account" label="账号" align="center">
                </el-table-column>
                <el-table-column label="所在企业树" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.zoomNames }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #035dff"
                      type="text"
                      @click="edit(scope.row, 2)"
                      >修改</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="ppfixed"
                style="bottom: 5px"
                @size-change="perhandleSizeChange"
                @current-change="perhandleCurrentChange"
                :current-page="percurrentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="perpageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pertotal"
                align="center"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <el-dialog
      :append-to-body="true"
      title="所在企业树"
      :visible.sync="dialogVisibleComtree"
      width="30%"
    >
      <el-table
        :data="tabzoomNames"
        v-loading="tableLoading"
        element-loading-text="列表加载中..."
        row-key="tabzoomNames"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="企业名称" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleComtree = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleComtree = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :append-to-body="true"
      title="选择企业树"
      :destroy-on-close="true"
      :visible.sync="unloadCompanyTreeShow"
      width="30%"
    >
      <el-table
        :data="tableData2"
        v-loading="tableLoading"
        element-loading-text="列表加载中..."
        ref="unloadCompany"
        row-key="unloadCompany"
      >
        <el-table-column align="center" type="index"> </el-table-column>
        <el-table-column align="center" property="name" label="姓名">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unloadCompanyTreeShow = false">取 消</el-button>
        <el-button @click="UpdateFamilyZoomSet" type="primary">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 
<script>
import {
  GetFamilyZoom,
  LoadFamilyZoom,
  UpdateFamilyZoomPosition,
  GetCompany,
  UpdateFamilyZoomSet,
  unLoadFamilyZoom,
} from "@/setAxios";
export default {
  name: "enterpriseTreeManagement_zk",
  components: {},
  data() {
    return {
      // 加载选择ids
      settingIds: "",
      // 卸载选择ids
      unLoadIds: "",
      activeName: "first",
      GouKeyword: "",
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      radio: false,
      tableData2: [],
      comKeyword: "",
      comtableData: [],
      comcurrentPage: 1,
      compageSize: 10,
      comtotal: 0,
      perKeyword: "",
      pertableData: [],
      percurrentPage: 1,
      perpageSize: 10,
      pertotal: 0,
      unloadCompanyTreeShow: false,
      unloadUserTreeShow: false,
      dialogVisibleComtree: false,
      tabzoomNames: [],
      value2: "",
      Keyword: "",
      companyId: "",
      userId: "",
      moveId: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    async UpdateFamilyZoomPosition(type) {
      if (this.moveId == "") {
        this.$message.error("请单选位移！");
        return false;
      } else {
        let params = {
          id: this.moveId,
          type: 1,
        };
        if (type == "up") {
          params.type = 1;
        } else {
          params.type = 2;
        }
        await UpdateFamilyZoomPosition(params);
        this.$refs.unloadTable.clearSelection();
        this.moveId = "";
        this.GetFamilyZoom();
      }
    },
    async UpdateFamilyZoomSet() {
      let unLoadIds = this.$refs.unloadCompany.selection
        .map((el) => el.id)
        .join();
      await UpdateFamilyZoomSet({
        id: this.companyId.length ? this.companyId : this.userId,
        zoomIds: unLoadIds,
        userType: this.companyId.length ? 1 : 0,
      });
      this.unloadCompanyTreeShow = false;
      this.companyId.length ? this.GetCompanyNewList() : this.perGetCompany();
    },
    // 企业——修改
    async unloadCompanySelectionChange(val) {
      console.log(val);
    },
    // 全部——加载选择过滤
    unloadhandleSelectionChange(val) {
      this.unLoadIds = val.map((el) => el.id).join();
      if (
        !val
          .map((el) => el.id)
          .join()
          .includes(",")
      ) {
        this.moveId = val.map((el) => el.id).join();
      }
    },
    // 全部——加载选择行事件
    unloadhandleRowClick(row, column, event) {
      this.$refs.unloadTable.toggleRowSelection(row);
      this.moveId = row.id;
      debugger;
    },
    // 全部——卸载api
    async unLoadFamilyZoom() {
      if (this.unLoadIds.length <= 0) {
        this.$message.error("请选择卸载企业");
        return;
      }
      let res = await unLoadFamilyZoom({ ids: this.unLoadIds });
      res.Code == 0
        ? this.$message.error("卸载失败")
        : this.$message.success("卸载成功") && this.GetFamilyZoom();
      this.$refs.unloadTable.clearSelection();
      this.$refs.multipleTableA.clearSelection();
      this.unLoadIds = "";
    },
    // 全部——加载选择过滤
    handleSelectionChange(val) {
      this.settingIds = val.map((el) => el.id).join();
    },
    // 全部——加载选择行事件
    handleRowClick(row, column, event) {
      this.$refs.multipleTableA.toggleRowSelection(row);
    },
    // 全部——加载api
    async loadGou() {
      if (this.settingIds.length <= 0) {
        this.$message.error("请选择加载企业");
        return;
      }
      let res = await LoadFamilyZoom({ ids: this.settingIds });
      res.Code == 0
        ? this.$message.error("已加载")
        : this.$message.success("加载成功") && this.GetFamilyZoom();
      this.$refs.unloadTable.clearSelection();
      this.$refs.multipleTableA.clearSelection();
      this.settingIds = "";
    },
    edit(item, type) {
      this.unloadCompanyTreeShow = true;
      if (type == 1) {
        this.userId = "";
        // 卸载企业树
        this.companyId = item.id.toString();
      } else {
        this.companyId = "";
        // 卸载人员树
        this.userId = item.id;
      }
      this.$nextTick(() => {
        if (this.$refs.unloadCompany && item.zoomIds != null) {
          this.tableData2
            .filter((el) => item.zoomIds.split(",").some((k) => k == el.id))
            .forEach((v) => {
              this.$refs.unloadCompany.toggleRowSelection(v);
            });
        }
      });
    },
    handleClick() {
      this.comGetCompany();
      this.perGetCompany();
    },
    //#region 表格分页
    perhandleSizeChange(val) {
      this.perpageSize = val;
      this.perGetCompany();
    },
    perhandleCurrentChange(val) {
      this.percurrentPage = val;
      this.perGetCompany();
    },
    comhandleSizeChange(val) {
      this.compageSize = val;
      this.comGetCompany();
    },
    comhandleCurrentChange(val) {
      this.comcurrentPage = val;
      this.comGetCompany();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetCompanyNewList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetCompanyNewList();
    },
    //#endregion

    async GetCompanyNewList() {
      this.tableLoading = true;
      let params = {
        searchword: this.GouKeyword,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        userType: 1,
      };
      let res = await GetCompany({ params });
      this.tableData = res.Data.list;
      this.tableLoading = false;

      this.total = res.Data.total;
    },
    quanbu(row) {
      this.dialogVisibleComtree = true;
      this.tabzoomNames = [];
      row.zoomNames.split(",").forEach((element) => {
        this.tabzoomNames.push({ name: element });
      });
    },
    async comGetCompany() {
      this.tableLoading = true;
      let params = {
        searchword: this.comKeyword,
        pageIndex: this.comcurrentPage,
        pageSize: this.compageSize,
        userType: 1,
      };
      let res = await GetCompany({ params });
      this.comtableData = res.Data.list;
      this.tableLoading = false;
      this.comtotal = res.Data.total;
    },
    async perGetCompany() {
      this.tableLoading = true;
      let params = {
        searchword: this.perKeyword,
        pageIndex: this.percurrentPage,
        pageSize: this.perpageSize,
        userType: 0,
      };
      let res = await GetCompany({ params });
      this.pertableData = res.Data.list;
      this.tableLoading = false;
      this.pertotal = res.Data.total;
    },
    newzoomNames(zoomNames) {
      if (zoomNames != null) {
        return zoomNames.length > 7
          ? zoomNames.slice(0, 8) + "......"
          : zoomNames;
      }
    },
    async GetFamilyZoom() {
      this.tableLoading = true;
      let res = await GetFamilyZoom();
      this.tableData2 = res.Data;
      this.tableLoading = false;
    },
  },
  created() {
    this.GetCompanyNewList();
    this.GetFamilyZoom();
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.enterpriseTreeManagement_zk {
  height: 100%;
  .el-card {
    height: 100%;
  }
  .el-card__header {
    border-bottom: none;
    span {
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: 700;
    }
  }
  .company {
    ::-webkit-input-placeholder {
      color: #000;
    }
    /deep/ .el-input__icon {
      color: #000;
    }
    /deep/ .el-input__inner {
      border-radius: 50px;
      background-color: #f2f4f8;
      border: none;
    }
  }
  /deep/.el-tabs__item {
    font-size: 18px !important;
    font-weight: 700;
    color: #999999;
  }
  /deep/.el-tabs__active-bar {
    background-color: #035dff;
    height: 4px;
    border-radius: 35px;
  }
  /deep/.el-tabs__item.is-active {
    color: #000;
  }
}
/deep/ .el-dialog .el-dialog__header {
  text-align: center;
}
</style>